<aa-action-circle *ngIf="trashable && (asyncTrashable| async)"
                  class="danger duotone clickable"
                  [faIcon]="'fal fa-trash-alt'"
                  [size]="'fa-1x'"
                  (click)="onClick($event)"
                  title="{{this.title}}">
</aa-action-circle>
